export default __webpack_public_path__ + "static/media/photo9.92005357.jpeg";